const TEXTS = {
  tabTitle: 'External Tool APIs',
  tabSubtitle: 'Configure external endpoints Clive calls for its integration tools.',
  addConfig: 'Add External Tool',
  editConfig: 'Edit External Tool',
  createConfig: 'Add External Tool',
  columns: {
    tool: 'Tool',
    url: 'URL',
    enabled: 'Enabled',
    schema: 'Response schema',
    edit: 'Edit',
    delete: 'Delete',
  },
  fields: {
    tool: 'Tool',
    url: 'URL',
    payloadFields: 'Payload Fields',
    enabled: 'Enabled',
    // Read-only: the method is fixed per tool, unlike the params the operator configures below.
    methodHelper: (method: string) =>
      `FiveSigma calls this endpoint with ${method}. The method is fixed per tool and cannot be changed.`,
  },
  payload: {
    key: 'Key',
    type: 'Type',
    title: 'Title',
    description: 'Description',
    required: 'Required',
    enumValues: 'Enum Values',
    addField: 'Add Payload Field',
    addEnumValue: 'Add Value',
    descriptionHelper: "The description drives the AI's extraction — be specific.",
  },
  queryParams: {
    helper:
      'Query-string parameters your endpoint expects. Name each parameter as your endpoint expects it, then choose which value FiveSigma should send in it — the value itself is filled in per call from the claim being handled.',
    paramName: 'Parameter',
    paramValue: 'Value sent by FiveSigma',
    addParam: 'Add Parameter',
    removeParam: 'Remove parameter',
  },
  extraHeaders: {
    helper:
      'Optional headers (e.g. a gateway credential) sent with every request to the endpoint. Values are encrypted and never shown again after saving.',
    configured:
      'Extra headers are currently configured. Their values are hidden — set a new set to replace them, or clear them.',
    mode: 'Extra Headers',
    modeKeepCreate: 'None',
    modeKeepEdit: 'Leave unchanged',
    modeReplace: 'Set new headers',
    modeClear: 'Clear all extra headers',
    headerName: 'Header Name',
    headerValue: 'Header Value',
    addHeader: 'Add Header',
    removeHeader: 'Remove header',
  },
  responseSchema: {
    title: 'Expected response schema',
    dialogTitle: (toolTitle: string) => `Expected response schema — ${toolTitle}`,
    previewTooltip: 'View expected response schema',
    noSchemaTooltip: 'No response schema is available for this tool',
    ownedBy: 'Defined by FiveSigma — your endpoint must return this.',
    version: (v: string) => `Contract version ${v}`,
    exampleHelper: 'Example of the response your endpoint must return.',
    freeForm: 'This response has no fixed fields — return a free-form object.',
    viewJsonSchema: 'View JSON Schema',
    copy: 'Copy schema',
    copyHelper: 'Copy the full technical schema to hand to whoever builds the endpoint.',
  },
  deleteConfirm: {
    title: 'Delete external tool config',
    body: (toolTitle: string) =>
      `Delete the external tool configuration for "${toolTitle}"? Clive will revert to internal search for this tool.`,
    primary: 'Delete',
    secondary: 'Cancel',
  },
  validation: {
    toastTitle: 'Please fix the following errors:',
    toolRequired: 'Select a tool',
    urlRequired: 'URL is required',
    urlHttps: 'URL must start with https://',
    urlInvalid: 'Enter a valid URL',
    keyRequired: 'Key is required',
    titleRequired: 'Title is required',
    descriptionRequired: 'Description is required',
    enumRequired: 'Add at least one enum value',
    duplicateKey: 'Payload field keys must be unique',
    headerNameRequired: 'Header name is required',
    duplicateHeader: 'Header names must be unique',
    queryParamNameRequired: 'Query parameter name is required',
    queryParamValueRequired: 'Choose which value FiveSigma sends in this query parameter',
    duplicateQueryParam: 'Query parameter names must be unique',
  },
  saveBlockedByToggle: 'Wait for the enable/disable change for this tool to finish before saving.',
  save: 'Save',
  cancel: 'Cancel',
  close: 'Close',
};

export default TEXTS;
